import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BackOfficeContractTransformer  {
    _originalTypeClassName = "zERP.BO.BackOfficeContractTransformer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficeContractTransformer.translate = translateService;
}
this.BackOfficeContractTransformerKey = null;
this._key = this.BackOfficeContractTransformerKey = 0; 
}

static translate: TranslateService;
_key: any;
private _BackOfficeContractTransformerKey:any;
get BackOfficeContractTransformerKey(): any {
    return this._BackOfficeContractTransformerKey;
  }
set BackOfficeContractTransformerKey(value: any) {
    this._BackOfficeContractTransformerKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BackOfficeContractTransformerKey == null || $this.BackOfficeContractTransformerKey == 0;
            }


}